import { Injectable, inject, Injector, runInInjectionContext } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Timestamp } from '@angular/fire/firestore';
import { from } from 'rxjs';

import { SMSData, SMSProvider } from '../../../../shared/db-models/sms';

@Injectable({
  providedIn: 'root',
})
export class SmsService {
  private injector: Injector;
  firestore: AngularFirestore;

  sendSmsInBulk(
    phoneNumbers: string[],
    smsMessage: string,
    time: Date,
    provider: SMSProvider,
    selectedStoresIds: string[],
    selectedSessionsIds: string[],
    defaultCountryCode: string,
    isTest: boolean
  ) {
    // Use compat API within injection context to avoid injection errors
    return runInInjectionContext(this.injector, () => {
      return from(
        this.firestore.collection<SMSData>('sms').add({
          phoneNumbers,
          sendWhen: Timestamp.fromDate(time),
          smsBody: smsMessage,
          wasSent: false,
          provider: provider,
          selectedStoresIds,
          selectedSessionsIds,
          defaultCountryCode,
          isTest,
        })
      );
    });
  }

  getAll() {
    // Use compat API within injection context to avoid injection errors
    return runInInjectionContext(this.injector, () => {
      return this.firestore.collection<SMSData>('sms').valueChanges();
    });
  }

  constructor() {
    this.firestore = inject(AngularFirestore);
    this.injector = inject(Injector);
  }
}
